<script setup>
import ClickableCell from '@/components/lists/ClickableCell';
// Props
const props = defineProps({
  tournament: {
    type: Object,
    default: () => null
  }
});
</script>

<template>
  <clickable-cell
      icon="mdi-trophy"
      tone="tournament"
      class="mb-3"
      :to="{ name: 'TournamentDetail', params: { tournamentId: props.tournament.id } }"
      :title="tournament.name"
      :subtitle="tournament.teamCount + ' competitors'"
  />
</template>
